import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../service/Api';

const BattlecardForm = () => {
  const [formData, setFormData] = useState({
    prospect: '',
    usecase: '',
    persona: '',
    context: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [battlecardData, setBattlecardData] = useState(null);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Helper function to extract domain from URL
  const extractDomain = (url) => {
    try {
      // Remove protocol and get just the domain
      let domain = url.replace(/^https?:\/\//, '').replace(/^www\./, '');
      // Remove trailing slash and path
      domain = domain.split('/')[0];
      return domain;
    } catch (error) {
      // If not a URL, return as-is (assuming it's already a domain)
      return url.trim();
    }
  };

  const generateBattleCard = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setBattlecardData(null);

    try {
      // Validate required fields
      if (!formData.prospect.trim()) {
        setError('Please enter a prospect domain');
        setLoading(false);
        return;
      }

      if (!formData.usecase.trim()) {
        setError('Please enter a use case');
        setLoading(false);
        return;
      }

      // Extract clean domain name from URL
      const cleanProspect = extractDomain(formData.prospect);
      
      // Call the API
      const response = await apiService.generateBattlecard(
        cleanProspect,
        formData.persona,
        formData.usecase,
        formData.context
      );

      console.log('Battlecard API response:', response);
      
      if (response.data && response.data.success && response.data.key) {
        setBattlecardData(response.data);
        // Navigate to the battlecard display page with the data
        navigate(`/battlecard/${response.data.key}`);
      } else {
        setError('Failed to generate battlecard. Please try again.');
      }
    } catch (err) {
      console.error('Error generating battlecard:', err);
      setError('Error generating battlecard: ' + (err.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#0f172a', 
      fontFamily: 'sans-serif', 
      color: '#e2e8f0',
      padding: '20px'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '32px 20px'
      }}>
        {/* Header Section */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '48px' 
        }}>
          {/* <h1 style={{ 
            fontSize: '40px',
            fontWeight: '800',
            color: '#ffffff',
            marginBottom: '16px',
            letterSpacing: '-0.025em'
          }}>
            Competitive Battle Card Generator
          </h1>
          <p style={{ 
            fontSize: '18px',
            color: '#94a3b8',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Create comprehensive competitive analysis battle cards to win more deals and accelerate your sales process
          </p> */}
        </div>

        {/* Main Form Card */}
        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto' 
        }}>
          <div style={{ 
            background: '#1e293b',
            borderRadius: '16px',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            border: '1px solid #334155',
            overflow: 'hidden'
          }}>
            {/* Card Header */}
            <div style={{ 
              background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
              padding: '32px',
              textAlign: 'center'
            }}>
              <h2 style={{ 
                fontSize: '24px',
                fontWeight: '700',
                color: '#ffffff',
                marginBottom: '8px'
              }}>
                Generate Battle Card
              </h2>
              <p style={{ 
                color: '#bfdbfe',
                fontSize: '16px'
              }}>
                Fill in the details below to create a professional battle card
              </p>
            </div>

            {/* Form Content */}
            <div style={{ padding: '32px' }}>
              <form onSubmit={generateBattleCard} style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                {/* Prospect Domain */}
                <div>
                  <label style={{ 
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    marginBottom: '12px'
                  }}>
                    Prospect Company Domain <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <div style={{ position: 'relative' }}>
                    <div style={{ 
                      position: 'absolute',
                      top: '50%',
                      left: '16px',
                      transform: 'translateY(-50%)',
                      pointerEvents: 'none'
                    }}>
                      <svg style={{ width: '20px', height: '20px', color: '#64748b' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9m0 0H3" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      name="prospect"
                      value={formData.prospect}
                      onChange={handleInputChange}
                      placeholder="Enter company domain (e.g., prospect.com)"
                      style={{ 
                        width: '100%',
                        padding: '16px 16px 16px 48px',
                        border: '1px solid #475569',
                        borderRadius: '8px',
                        fontSize: '16px',
                        background: '#1e293b',
                        color: '#e2e8f0',
                        outline: 'none',
                        transition: 'border-color 0.2s'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                      onBlur={(e) => e.target.style.borderColor = '#475569'}
                      required
                    />
                  </div>
                  <p style={{ 
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#94a3b8'
                  }}>
                    Enter the domain of the prospect company you want to analyze
                  </p>
                </div>

                {/* Use Case */}
                <div>
                  <label style={{ 
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    marginBottom: '12px'
                  }}>
                    Use Case / Business Scenario <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <textarea
                    name="usecase"
                    value={formData.usecase}
                    onChange={handleInputChange}
                    placeholder="Describe the specific use case or business scenario"
                    rows={4}
                    style={{ 
                      width: '100%',
                      padding: '16px',
                      border: '1px solid #475569',
                      borderRadius: '8px',
                      fontSize: '16px',
                      background: '#1e293b',
                      color: '#e2e8f0',
                      outline: 'none',
                      transition: 'border-color 0.2s',
                      resize: 'none',
                      fontFamily: 'inherit'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                    onBlur={(e) => e.target.style.borderColor = '#475569'}
                    required
                  />
                  <p style={{ 
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#94a3b8'
                  }}>
                    Provide context about the specific business scenario or competitive situation
                  </p>
                </div>

                {/* Persona */}
                <div>
                  <label style={{ 
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    marginBottom: '12px'
                  }}>
                    Target Persona
                  </label>
                  <div style={{ position: 'relative' }}>
                    <div style={{ 
                      position: 'absolute',
                      top: '50%',
                      left: '16px',
                      transform: 'translateY(-50%)',
                      pointerEvents: 'none'
                    }}>
                      <svg style={{ width: '20px', height: '20px', color: '#64748b' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      name="persona"
                      value={formData.persona}
                      onChange={handleInputChange}
                      placeholder="e.g., Sales Director, CTO, VP of Engineering"
                      style={{ 
                        width: '100%',
                        padding: '16px 16px 16px 48px',
                        border: '1px solid #475569',
                        borderRadius: '8px',
                        fontSize: '16px',
                        background: '#1e293b',
                        color: '#e2e8f0',
                        outline: 'none',
                        transition: 'border-color 0.2s'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                      onBlur={(e) => e.target.style.borderColor = '#475569'}
                    />
                  </div>
                  <p style={{ 
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#94a3b8'
                  }}>
                    The decision maker or stakeholder role you're targeting
                  </p>
                </div>

                {/* Context */}
                <div>
                  <label style={{ 
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    marginBottom: '12px'
                  }}>
                    Additional Context
                  </label>
                  <textarea
                    name="context"
                    value={formData.context}
                    onChange={handleInputChange}
                    placeholder="Any additional context, background information, specific requirements, or competitive dynamics..."
                    rows={5}
                    maxLength={10000}
                    style={{ 
                      width: '100%',
                      padding: '16px',
                      border: '1px solid #475569',
                      borderRadius: '8px',
                      fontSize: '16px',
                      background: '#1e293b',
                      color: '#e2e8f0',
                      outline: 'none',
                      transition: 'border-color 0.2s',
                      resize: 'none',
                      fontFamily: 'inherit'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                    onBlur={(e) => e.target.style.borderColor = '#475569'}
                  />
                  <div style={{ 
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '8px'
                  }}>
                    <p style={{ 
                      fontSize: '14px',
                      color: '#94a3b8'
                    }}>
                      Additional context to enhance the battle card analysis
                    </p>
                    <span style={{ 
                      fontSize: '12px',
                      color: '#64748b'
                    }}>
                      {formData.context.length}/10,000
                    </span>
                  </div>
                </div>

                {/* Submit Button */}
                <div style={{ paddingTop: '16px' }}>
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '16px 32px',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      border: 'none',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      transition: 'all 0.2s',
                      background: loading 
                        ? '#475569' 
                        : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                      color: '#ffffff',
                      transform: loading ? 'none' : 'scale(1)',
                      boxShadow: loading ? 'none' : '0 10px 15px -3px rgba(59, 130, 246, 0.3)'
                    }}
                    onMouseEnter={(e) => !loading && (e.target.style.transform = 'scale(1.02)')}
                    onMouseLeave={(e) => !loading && (e.target.style.transform = 'scale(1)')}
                  >
                    {loading ? (
                      <>
                        <svg style={{ 
                          animation: 'spin 1s linear infinite',
                          marginRight: '12px',
                          width: '20px',
                          height: '20px'
                        }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle style={{ opacity: '0.25' }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path style={{ opacity: '0.75' }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Generating Battle Card...
                      </>
                    ) : (
                      <>
                        <svg style={{ width: '20px', height: '20px', marginRight: '8px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        Generate Battle Card
                      </>
                    )}
                  </button>
                </div>
              </form>

              {/* Error Display */}
              {error && (
                <div style={{ 
                  marginTop: '24px',
                  padding: '16px',
                  background: 'rgba(239, 68, 68, 0.1)',
                  border: '1px solid #f87171',
                  borderRadius: '8px'
                }}>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flexShrink: '0' }}>
                      <svg style={{ width: '20px', height: '20px', color: '#f87171' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div style={{ marginLeft: '12px' }}>
                      <p style={{ fontSize: '14px', color: '#f87171' }}>{error}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Info Section */}
          <div style={{ 
            marginTop: '32px',
            textAlign: 'center'
          }}>
            <div style={{ 
              background: '#1e293b',
              borderRadius: '12px',
              padding: '24px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              border: '1px solid #334155'
            }}>
              <h3 style={{ 
                fontSize: '18px',
                fontWeight: '600',
                color: '#ffffff',
                marginBottom: '12px'
              }}>
                What you'll get
              </h3>
              <div style={{ 
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '24px',
                fontSize: '14px',
                color: '#94a3b8'
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ 
                    width: '48px',
                    height: '48px',
                    background: 'rgba(59, 130, 246, 0.1)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '12px'
                  }}>
                    <svg style={{ width: '24px', height: '24px', color: '#3b82f6' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <span style={{ fontWeight: '500', color: '#e2e8f0' }}>Competitive Analysis</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ 
                    width: '48px',
                    height: '48px',
                    background: 'rgba(34, 197, 94, 0.1)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '12px'
                  }}>
                    <svg style={{ width: '24px', height: '24px', color: '#22c55e' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                  <span style={{ fontWeight: '500', color: '#e2e8f0' }}>Value Propositions</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ 
                    width: '48px',
                    height: '48px',
                    background: 'rgba(168, 85, 247, 0.1)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '12px'
                  }}>
                    <svg style={{ width: '24px', height: '24px', color: '#a855f7' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                  </div>
                  <span style={{ fontWeight: '500', color: '#e2e8f0' }}>Talking Points</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default BattlecardForm; 